/* eslint-disable react/prop-types */
import React, { useEffect } from "react";
import SoftBox from "components/SoftBox";
import SoftButton from "components/SoftButton";

export function SummaryOfDetailedInfo({ formData }) {
  const { values, setFieldValue, containView } = formData;
  const { details = [] } = values;

  const handleChangeField = (path, val) => {
    setFieldValue(path, val);
  };

  const handleChangeTable = (index, field, val) => {
    const newDetails = [...details];
    newDetails[index][field] = val;

    // Tự động tính cột 4 = cột 1 + cột 2 - cột 3 (Tồn cuối kỳ)
    if (field === "openingBalance" || field === "inwardAmount" || field === "outwardAmount") {
      const open = parseFloat(newDetails[index].openingBalance) || 0;
      const inward = parseFloat(newDetails[index].inwardAmount) || 0;
      const outward = parseFloat(newDetails[index].outwardAmount) || 0;
      newDetails[index].closingBalance = open + inward - outward;
    }

    setFieldValue("details", newDetails);
  };

  // Tính tổng cộng tự động mỗi khi details thay đổi
  useEffect(() => {
    const totalOpen = details.reduce((acc, row) => acc + (parseFloat(row.openingBalance) || 0), 0);
    const totalIn = details.reduce((acc, row) => acc + (parseFloat(row.inwardAmount) || 0), 0);
    const totalOut = details.reduce((acc, row) => acc + (parseFloat(row.outwardAmount) || 0), 0);
    const totalClose = details.reduce((acc, row) => acc + (parseFloat(row.closingBalance) || 0), 0);

    setFieldValue("totalOpeningBalance", totalOpen);
    setFieldValue("totalInwardAmount", totalIn);
    setFieldValue("totalOutwardAmount", totalOut);
    setFieldValue("totalClosingBalance", totalClose);
  }, [JSON.stringify(details.map(d => ({ o: d.openingBalance, i: d.inwardAmount, ou: d.outwardAmount })))]);

  const addRow = () => {
    const template = {
      ordinalNumber: String(details.length + 1).padStart(2, "0"),
      name: "",
      openingBalance: 0,
      inwardAmount: 0,
      outwardAmount: 0,
      closingBalance: 0,
    };
    setFieldValue("details", [...details, template]);
  };

  const removeRow = (index) => {
    if (details.length <= 1) return;
    const newDetails = details.filter((_, i) => i !== index).map((row, idx) => ({
      ...row,
      ordinalNumber: String(idx + 1).padStart(2, "0"),
    }));
    setFieldValue("details", newDetails);
  };

  const fmt = (n) => (n && n !== 0 ? new Intl.NumberFormat("vi-VN").format(n) : "0");

  const s = {
    container: { fontFamily: '"Times New Roman", Times, serif', color: "#000", padding: "20px", backgroundColor: "#fff", fontSize: "14px", lineHeight: "1.5" },
    headerTop: { display: "flex", justifyContent: "space-between", marginBottom: "15px" },
    titleBox: { textAlign: "center", margin: "10px 0" },
    inputDotted: { border: "none", borderBottom: "1px dotted #000", outline: "none", fontSize: "14px", fontFamily: "inherit", backgroundColor: "transparent", color: "#000", fontWeight: "bold" },
    inputDottedSmall: { border: "none", borderBottom: "1px dotted #000", outline: "none", width: "40px", fontSize: "14px", fontFamily: "inherit", textAlign: "center", backgroundColor: "transparent", color: "#000", fontWeight: "bold" },
    table: { width: "100%", borderCollapse: "collapse", fontSize: "13px", marginTop: "15px", marginBottom: "15px" },
    th: { border: "1px solid #000", padding: "8px 4px", textAlign: "center", fontWeight: "bold", verticalAlign: "middle", backgroundColor: "#fff" },
    td: { border: "1px solid #000", padding: 0, height: "35px", verticalAlign: "middle" },
    inputTable: { width: "100%", height: "100%", border: "none", outline: "none", padding: "0 8px", fontSize: "13px", fontFamily: "inherit", background: "transparent", color: "#000" },
    inputTableCenter: { width: "100%", height: "100%", border: "none", outline: "none", textAlign: "center", fontSize: "13px", fontFamily: "inherit", background: "transparent", color: "#000" },
    inputTableRight: { width: "100%", height: "100%", border: "none", outline: "none", textAlign: "right", padding: "0 8px", fontSize: "13px", fontFamily: "inherit", background: "transparent", color: "#000" },
    removeBtn: { border: "none", background: "transparent", color: "red", cursor: "pointer", fontWeight: "bold", fontSize: "16px" },
    rowLabel: { display: "flex", alignItems: "baseline", gap: "5px", marginBottom: "8px" }
  };

  return (
    <SoftBox style={s.container}>
      {/* HEADER */}
      <div style={s.headerTop}>
        <div style={{ width: "40%" }}>
          <div style={s.rowLabel}>Đơn vị: <input disabled={containView} style={{ ...s.inputDotted, flex: 1 }} value={values.unit} onChange={(e) => handleChangeField("unit", e.target.value)} /></div>
          <div style={s.rowLabel}>Địa chỉ: <input disabled={containView} style={{ ...s.inputDotted, flex: 1 }} value={values.address} onChange={(e) => handleChangeField("address", e.target.value)} /></div>
        </div>
        <div style={{ textAlign: "center", width: "60%" }}>
          <div style={{ fontWeight: "bold", fontSize: "15px" }}>Mẫu số S11-DN</div>
          <div style={{ fontStyle: "italic", fontSize: "11px" }}>(Kèm theo Thông tư số 99/2025/TT-BTC <br /> ngày 27 tháng 10 năm 2025 của Bộ trưởng Bộ Tài chính)</div>
        </div>
      </div>

      {/* TITLE */}
      <div style={s.titleBox}>
        <h2 style={{ margin: 0, textTransform: "uppercase", fontSize: "18px" }}>BẢNG TỔNG HỢP CHI TIẾT VẬT LIỆU, DỤNG CỤ, SẢN PHẨM, HÀNG HÓA</h2>
        <div style={{ marginTop: 10, fontWeight: "bold" }}>
          Tài khoản: <input disabled={containView} style={{ ...s.inputDotted, width: "150px", textAlign: "center" }} value={values.accountNumber} onChange={(e) => handleChangeField("accountNumber", e.target.value)} />
        </div>
        <div style={{ marginTop: 5 }}>
          Tháng: <input disabled={containView} style={{ ...s.inputDotted, width: "150px", textAlign: "center" }} value={values.monthYear} onChange={(e) => handleChangeField("monthYear", e.target.value)} />
        </div>
      </div>

      {/* TABLE 6 COLUMNS */}
      <div style={{ overflowX: "auto" }}>
        <table style={s.table}>
          <thead>
            <tr>
              <th style={{ ...s.th, width: "60px" }} rowSpan={2}>STT</th>
              <th style={s.th} rowSpan={2}>Tên, quy cách vật liệu, dụng cụ, sản phẩm, hàng hóa</th>
              <th style={s.th} colSpan={4}>Số tiền</th>
              {!containView && <th style={{ ...s.th, width: "40px" }} rowSpan={3}>#</th>}
            </tr>
            <tr>
              <th style={{ ...s.th, width: "120px" }}>Tồn đầu kỳ</th>
              <th style={{ ...s.th, width: "120px" }}>Nhập trong kỳ</th>
              <th style={{ ...s.th, width: "120px" }}>Xuất trong kỳ</th>
              <th style={{ ...s.th, width: "120px" }}>Tồn cuối kỳ</th>
            </tr>
            <tr style={{ backgroundColor: "#f0f0f0" }}>
              <th style={s.th}>A</th>
              <th style={s.th}>B</th>
              <th style={s.th}>1</th>
              <th style={s.th}>2</th>
              <th style={s.th}>3</th>
              <th style={s.th}>4</th>
              {!containView && <th style={s.th}></th>}
            </tr>
          </thead>
          <tbody>
            {details.map((item, idx) => (
              <tr key={idx}>
                <td style={s.td}><input disabled={containView} style={s.inputTableCenter} value={item.ordinalNumber} onChange={(e) => handleChangeTable(idx, "ordinalNumber", e.target.value)} /></td>
                <td style={s.td}><input disabled={containView} style={s.inputTable} value={item.name} onChange={(e) => handleChangeTable(idx, "name", e.target.value)} /></td>
                <td style={s.td}><input disabled={containView} type="number" style={s.inputTableRight} value={item.openingBalance} onChange={(e) => handleChangeTable(idx, "openingBalance", e.target.value)} /></td>
                <td style={s.td}><input disabled={containView} type="number" style={s.inputTableRight} value={item.inwardAmount} onChange={(e) => handleChangeTable(idx, "inwardAmount", e.target.value)} /></td>
                <td style={s.td}><input disabled={containView} type="number" style={s.inputTableRight} value={item.outwardAmount} onChange={(e) => handleChangeTable(idx, "outwardAmount", e.target.value)} /></td>
                <td style={s.td}><input disabled style={s.inputTableRight} value={fmt(item.closingBalance)} /></td>
                {!containView && <td style={{ ...s.td, textAlign: "center" }}><button type="button" style={s.removeBtn} onClick={() => removeRow(idx)}>–</button></td>}
              </tr>
            ))}
            {/* DÒNG CỘNG */}
            <tr style={{ fontWeight: "bold", backgroundColor: "#fafafa" }}>
              <td style={{ ...s.td, textAlign: "center" }} colSpan={2}>Cộng</td>
              <td style={{ ...s.td, textAlign: "right", paddingRight: "8px" }}>{fmt(values.totalOpeningBalance)}</td>
              <td style={{ ...s.td, textAlign: "right", paddingRight: "8px" }}>{fmt(values.totalInwardAmount)}</td>
              <td style={{ ...s.td, textAlign: "right", paddingRight: "8px" }}>{fmt(values.totalOutwardAmount)}</td>
              <td style={{ ...s.td, textAlign: "right", paddingRight: "8px" }}>{fmt(values.totalClosingBalance)}</td>
              {!containView && <td style={s.td}></td>}
            </tr>
          </tbody>
        </table>
        {!containView && (
          <SoftBox textAlign="center" mb={2}>
            <SoftButton variant="outlined" color="dark" size="small" onClick={addRow}>+ Thêm dòng</SoftButton>
          </SoftBox>
        )}
      </div>

      {/* FOOTER: SIGNATURES */}
      {/* <div style={{ display: "flex", justifyContent: "space-between", marginTop: "30px", textAlign: "center" }}>
        <div style={{ width: "30%" }}>
          <div style={{ fontWeight: "bold" }}>Người ghi sổ</div>
          <div style={{ fontStyle: "italic", fontSize: "12px" }}>(Ký, họ tên)</div>
          <SoftBox mt={8}>
            <input disabled={containView} style={{ ...s.inputDotted, width: "150px", textAlign: "center" }} value={values.ledgerClerk} onChange={(e) => handleChangeField("ledgerClerk", e.target.value)} />
          </SoftBox>
        </div>
        <div style={{ width: "30%" }}>
          <div style={{ fontWeight: "bold" }}>Kế toán trưởng</div>
          <div style={{ fontStyle: "italic", fontSize: "12px" }}>(Ký, họ tên)</div>
          <SoftBox mt={8}>
            <input disabled={containView} style={{ ...s.inputDotted, width: "150px", textAlign: "center" }} value={values.chiefAccountant} onChange={(e) => handleChangeField("chiefAccountant", e.target.value)} />
          </SoftBox>
        </div>
        <div style={{ width: "40%" }}>
          <div style={{ fontStyle: "italic", fontSize: "14px", marginBottom: "5px" }}>
            Ngày <input disabled={containView} style={s.inputDottedSmall} value={values.signingDay} onChange={(e) => handleChangeField("signingDay", e.target.value)} /> tháng <input disabled={containView} style={s.inputDottedSmall} value={values.signingMonth} onChange={(e) => handleChangeField("signingMonth", e.target.value)} /> năm <input disabled={containView} style={{ ...s.inputDottedSmall, width: "50px" }} value={values.signingYear} onChange={(e) => handleChangeField("signingYear", e.target.value)} />
          </div>
          <div style={{ fontWeight: "bold" }}>Người đại diện theo pháp luật</div>
          <div style={{ fontStyle: "italic", fontSize: "12px" }}>(Ký, họ tên, đóng dấu)</div>
          <SoftBox mt={8}>
            <input disabled={containView} style={{ ...s.inputDotted, width: "200px", textAlign: "center" }} value={values.legalRepresentative} onChange={(e) => handleChangeField("legalRepresentative", e.target.value)} />
          </SoftBox>
        </div>
      </div> */}
    </SoftBox>
  );
}
